import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import classnames from "classnames";
import styles from "./Title.module.scss";
export var Title = function Title(a) {
  var b = a.header,
      c = a.text,
      d = a.secondaryText,
      e = a.className,
      f = a.small;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(e, styles.container, _defineProperty({}, styles.small, f))
  }, /*#__PURE__*/React.createElement("h4", {
    className: styles.header
  }, b), /*#__PURE__*/React.createElement("h1", {
    className: classnames(styles.text, "package--title-text")
  }, c), d && /*#__PURE__*/React.createElement("h1", {
    className: classnames(styles.secondaryText, "package--secondary-text")
  }, d));
};
export default Title;